<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Thẩm định sản phẩm</div>
      </div>
      <div class="card card-w-title">
        <div class="list-data">
          <div class="list-title">
            <span class="p-m-0">Danh sách tiếp nhận yêu cầu thẩm định</span>
            <span class="p-input-icon-left" >
              <!-- <span class="p-input-icon-left"> -->
              <Button
                v-if="$myConstants.checkRoleGroup('appraisal_product', 'add')"
                :label="'Tạo phiếu tiếp nhận'"
                type="button"
                v-on:click="onActionClicked({action: {name: 'add', label: 'Tạo phiếu tiếp nhận'}, key: 'add'})"
              > </Button>
            </span>
          </div>
          <BaseCommon v-if="dataModel"
            :key="componentKey"
            :listData="listData"
            :model="dataModel"
            :filterDefault="filters"
            :actions="getRowActions()"
            v-on:action-click="onActionClicked"
            @filterExport="filterExport"
          ></BaseCommon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
//import BaseCommon from '../common'
import BaseCommon from './core_list';
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      filters: {},
      listData: [],
      dataModel: null,
      componentKey: 0,
      data_filter_export:null
    }
  },
  mounted () {
    this.initData();
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initData'
  },
  methods: {
    initData() {
      setTimeout(async () => {
        if (this.$myConstants.checkRoleGroup('appraisal_product', 'list')) {
        await this.initParams();
        }
      }, 1000);
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    async initParams() {
     /* var organization = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
      var id_organization_hong_ky =await this.$coreService.id_organization_hong_ky();
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);*/
      this.modelName = 'appraisal';
      /*var whereKey = {
        status: {'_in': [0,1] }
      }*/
      //Phân quyền dữ liệu
     /* var is_management_units = false;
      if (parseFloat(id_organization_hong_ky) ==  creator_organization_id){
        if (!this.$myConstants.isEmpty(this.$store.getters.fullname.is_management_units)){
          if (this.$store.getters.fullname.is_management_units == true){
            is_management_units = true;
          }
        }
      }
      if (is_management_units == false){
        //whereKey.request_organization_id = {'_eq': creator_organization_id};
        whereKey.organization_id  = {'_eq': creator_organization_id};
      }
      var variables = {
        where_key: whereKey,
        orderBy: {
          status: 'asc',
          id: 'desc',
          created_date: 'desc',
          modified_date: 'desc'
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];*/
      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData([]);
      this.listData = [];
      this.componentKey++;
      //this.$store.commit('setLoading', false);
    },
    
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'add':
          // if (this.checkVisible('product', 'add')) {
            this.$router.push({path: '/admin/appraisal-product/function'});
          //}
          break;
        case 'view':
          //if(this.checkVisible('warranty_activation', 'view')) {
            this.$router.push(action.path + '/' + data.data[action.key])
          //}
          break;
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        if(that.$myConstants.checkRoleGroup('appraisal_product', 'view_detail')) {
          buttons.view = { name: 'view', text: 'Xem', isText: true, key: 'id', path: `/admin/appraisal-product/view`}
          if (that.dataModel.actions) {
            var modelaction = that.dataModel.actions(rowData)
            Object.assign(buttons, modelaction);
          }
        }
        return buttons
      }
      return actions
    },
    cancelFilter() {
      this.filters = {};
    },
    async filterExport(e){
      //console.log("EEE",e)
      this.data_filter_export = e
    }
  }
}
</script>
<style lang="scss">
.box-filters{ margin: 15px 0;
  .p-formgroup-inline { display: flex;flex-wrap: wrap; align-items: flex-start;
    .p-field{ margin-right: 50px; margin-bottom: 15px;
      &:last-child{margin: 0; position: relative;}
      label{display: block;}
      .p-dropdown, input{width: 230px;}
      .btn-cancel{width: 90px;position: absolute; top: 30px;}
    }
  }
}
.external-link{ color: #0066FF; cursor: pointer;
  &.black-color {
    span{color: #000;}
  }
  span{color: #199ED8;}
}
</style>